import { Component, OnInit, OnDestroy } from '@angular/core';
import { CryptokeysApi, Key } from './cryptokeys-api';
import { CodeName, GenericHelper } from '../../commons/generic-helper';
import { Subject, BehaviorSubject, of, merge, combineLatest } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsChooserComponent } from '../settings-chooser/settings-chooser.component';
import { switchMap, tap, takeUntil, catchError } from 'rxjs/operators';
import { DeleteCryptokeyComponent } from './delete-cryptokey/delete-cryptokey.component';
import { HttpErrorResponse } from '@angular/common/http';
import { UpsertCryptokeyComponent } from './upsert-cryptokey/upsert-cryptokey.component';
import { CommonApi } from '../../commons/common-api';

@Component({
  selector: 'app-cryptokeys',
  templateUrl: './cryptokeys.component.html',
  styleUrls: ['./cryptokeys.component.scss']
})
export class CriptokeysComponent implements OnInit, OnDestroy {

  customerList: CodeName[];
  customerPlantList: CodeName[];
  keyList: string[];
  unsubscribe = new Subject<void>();
  customer = new FormControl(null, [Validators.required]);

  keys = new BehaviorSubject<Key[]>(null);

  constructor(private commonApi: CommonApi, private api: CryptokeysApi, private modal: NgbModal, private readonly parent: SettingsChooserComponent) {
    this.commonApi.getCustomerList().subscribe(x => this.customerList = x);
    this.api.getKeyList().subscribe(x => this.keyList = x);

    this.customer.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        tap(x => this.parent.showProgressbar()),
        takeUntil(this.unsubscribe),
        tap(x => console.log(x)),
        switchMap((customerId: number) =>
          combineLatest(
            this.api.get(customerId),
            this.commonApi.getCustomerPlantList(this.customer.value)
          )
        )
      )
      .subscribe(x => {
        this.keys.next(x[0]);
        this.customerPlantList = x[1];
        this.parent.hideProgressbar()
      });
  }

  ngOnInit(): void {
  }

  async upsert(row: Key = null) {
    let insertNew: boolean = row == null;

    let ref = await this.modal.open(UpsertCryptokeyComponent);
    let toEdit: Key = GenericHelper.initFromInstance(row);
    if (insertNew) {
      toEdit["id"] = null;
    }

    ref.componentInstance.key = toEdit;
    ref.componentInstance.plantList = this.customerPlantList;
    ref.componentInstance.usedKeys = this.keyList;
    ref.componentInstance.title = insertNew ? "Add new key" : "Edit key";

    try {
      let result = await ref.result;
      this.api.upsert(this.customer.value, toEdit)
        .pipe(
          tap(() => this.parent.showProgressbar()),
          catchError((x: HttpErrorResponse) => {
            console.log("❌ " + x.error);
            this.parent.showError();
            return of([]);
          }),
          switchMap(x => this.api.get(this.customer.value))
        )
        .subscribe(newList => { this.parent.showSuccess();this.keys.next(newList); this.parent.hideProgressbar() })

    } catch{ }
  }

  async delete(row: Key) {
    let ref = await this.modal.open(DeleteCryptokeyComponent);
    ref.componentInstance.key = row;

    try {
      let result = await ref.result;
      this.api.delete(row)
        .pipe(
          tap(() => this.parent.showProgressbar()),
          catchError((x: HttpErrorResponse) => {
            console.log("❌ " + x.error);
            this.parent.showError();
            return of([]);
          }),
          switchMap(x => this.api.get(this.customer.value))
        )
        .subscribe(newList => { this.parent.showSuccess();this.keys.next(newList); this.parent.hideProgressbar() })

    } catch{ }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
